export default __webpack_public_path__ + "static/media/jobBoard.630d1edc.png";